/* unplugin-vue-components disabled */import script from "./register_copy.vue?vue&type=script&setup=true&lang=js"
export * from "./register_copy.vue?vue&type=script&setup=true&lang=js"

import "./register_copy.vue?vue&type=style&index=0&id=c8fd62fe&scoped=true&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8fd62fe"]])

export default __exports__